export default __webpack_public_path__ + "static/media/dubai-science-park.964f1ed1.png";